import React, { useEffect, useState, useRef } from "react";
import styles from "./styles//virtual.module.css";
import Navbar from "../component/navbar/Navbar"
import Banner from "../component/banner/Banner";
import bannerImg from "../assets/images/bannerImg.png"
import lineRV from "../assets/images/lineRV.png"
import lineLV from "../assets/images/lineLV.png"
import Footer from "../component/footer/Footer"
import virtualjungle from "../assets/images/virtualjungle.png"
import virtualsa from "../assets/images/virtualsa.png"

const Virtual = () => {
  const [scrollPositions, setScrollPositions] = useState([0, 0]);
  const titleRefs = [useRef(null), useRef(null)];

  useEffect(() => {
    const handleScroll = () => {
      const positions = titleRefs.map((ref) => {
        const titleTop = ref.current.offsetTop;
        const titleHeight = ref.current.offsetHeight;
        const scrollTop = window.scrollY;
        const scrollBottom = scrollTop + window.innerHeight;

        // check if the title is in view
        if (scrollTop < titleTop + titleHeight && scrollBottom > titleTop) {
          const progress = (scrollBottom - titleTop) / (titleHeight + window.innerHeight);
          return progress;
        } else {
          return 0;
        }
      });

      setScrollPositions(positions);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const titleStyles = scrollPositions.map((progress, index) => ({
    background: `linear-gradient(to left, #5618C5 ${progress * 180}%, transparent 0)`,
  }));

  return (
    <>
      <div>
        <div>
          <Navbar />
        </div>
        <div className={styles.contant}>
          <Banner bannerImage={bannerImg} mouseImage={styles.non} />
        </div>
        <div className={styles.containerTitle}>
          <img className={styles.lineFront} src={lineRV} alt="lineR" />
          <div className={styles.titleBackground}>
            <h1 ref={titleRefs[0]} style={titleStyles[0]} className={styles.titleText}>
              {" "}
              طبقه ساحلی
            </h1>
          </div>
          <img className={styles.lineFront} src={lineLV} alt="lineL" />
        </div>
        <div className={styles.videoContainer}>
          <div className={styles.virtualTour}>
            <a href="https://heliumpark.ir/%D8%AA%D9%88%D8%B1%D9%85%D8%AC%D8%A7%D8%B2%DB%8C%20%D8%B3%D8%A7%D8%AD%D9%84/index.htm">
              <img className={styles.virtualImg} alt="virtualsrc" src={virtualsa} />
            </a>
          </div>
        </div>
        <div className={styles.containerTitle}>
          <img className={styles.lineFront} src={lineRV} alt="lineR" />
          <div className={styles.titleBackground}>
            <h1 ref={titleRefs[1]} style={titleStyles[1]} className={styles.titleText}>
              طبقه جنگلی
            </h1>
          </div>
          <img className={styles.lineFront} src={lineLV} alt="lineL" />
        </div>
        <div className={styles.videoContainer}>
          <div className={styles.virtualTour}>
            <a href="https://heliumpark.ir/%D8%AA%D9%88%D8%B1%D9%85%D8%AC%D8%A7%D8%B2%DB%8C%20%D8%AC%D9%86%DA%AF%D9%84/index.htm">
              <img className={styles.virtualImg} alt="virtualsrc" src={virtualjungle} />
            </a>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Virtual;